<template>
    <div class="password">
        <div class="pwd-content">
            <div style="padding: 32px 59px;">
                <div class="p-title">
                    <div class="text">修改密码</div>
                    <div class="title-line"></div>
                </div>
                <el-form ref="formRevisPwd" :model="formRevisPwd" :rules="rulesRegister" label-width="0px">
                    <el-form-item prop="oldPassword">
                        <el-input placeholder="请输入旧密码" v-model="formRevisPwd.oldPassword" show-password></el-input>
                    </el-form-item>
                    <el-form-item prop="newPassword">
                        <el-input placeholder="请设置新密码" v-model="formRevisPwd.newPassword" show-password></el-input>
                    </el-form-item>
                    <el-form-item prop="password">
                        <el-input placeholder="请重复新密码" v-model="formRevisPwd.newPasswords" show-password></el-input>
                    </el-form-item>
                </el-form>
                <div>
                    <el-button @click="clickRevise('formRevisPwd')" style="width: 100%;" type="primary">立即修改</el-button>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            formRevisPwd: {
                userId: '',
                newPassword: '',
                newPasswords: '',
                oldPassword: ''
            },
            rulesRegister: {
                oldPassword: [
                    { required: true, message: '请输入旧密码', trigger: 'blur' },
                ],
                newPassword: [
                    { required: true, message: '请输入新密码', trigger: 'blur' }
                ],
                newPasswords: [
                    { required: true, message: '请重复新密码', trigger: 'blur' }
                ],

            }
        }
    },
    methods: {
        clickRevise(formName) {
            let that = this
            that.formRevisPwd.userId = this.$store.state.userId
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (that.formRevisPwd.newPassword == that.formRevisPwd.newPasswords) {
                        that.apis.changePassword(that.formRevisPwd).then(res => {
                            if (res.code == 0) {
                                this.$message({
                                    message: '密码修改成功',
                                    type: 'error'
                                });
                                that.$router.go(-1)
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error'
                                });
                            }
                        })
                    } else {
                        this.$message({
                            message: '两次密码输入不一致，请重新输入！',
                            type: 'warning'
                        });
                    }
                } else {
                    this.$message({
                        message: '请输入完整信息',
                        type: 'warning'
                    });
                }
            })
        }
    }

}
</script>
<style>
.password {
    width: 100%;
    height: 100vh;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
}

.pwd-content {
    width: 480px;
    background: #FFFFFF;
    box-shadow: 0px 5px 125px 0px rgba(55, 63, 69, 0.05);
    border-radius: 20px 20px 20px 20px;
    opacity: 1;

}

.password .pwd-content .p-title .text {
    font-size: 28px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 600;
    color: #242627;
    line-height: 38px;
}

.password .pwd-content .p-title .title-line {
    width: 81px;
    height: 6px;
    background: linear-gradient(135deg, #5ACEFF 0%, #5AA6FF 100%);
    border-radius: 23px 23px 23px 23px;
    opacity: 1;
    margin-bottom: 27px;
}
</style>


// WEBPACK FOOTER //
// src/views/set-up/password.vue